import { Component, OnDestroy } from '@angular/core';
import {
  NotificationsAdapter,
  TNotification,
} from '../../../../domain/adapters/notifications.adapter';
import { Subscription } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'otw-notifications-provider',
  standalone: true,
  imports: [DialogModule, Button, CommonModule],
  templateUrl: './notifications-provider.component.html',
  styles: ``,
})
export class NotificationsProviderComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  lastNotification: TNotification | null = null;
  notificationModalVisible: boolean = false;

  constructor(private notificationsService: NotificationsAdapter) {}

  onNewNotification(notification: TNotification) {
    this.lastNotification = notification;
    this.notificationModalVisible = true;
  }

  onCloseModal() {
    this.notificationModalVisible = false;
    this.notificationsService.updateUserAction('closed');
  }

  ngOnInit(): void {
    const notificationsSub = this.notificationsService.notifications$.subscribe(
      (notification) => {
        this.onNewNotification(notification);
      }
    );

    this.subscriptions.push(notificationsSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
